module.exports = "https://web-assets.ifttt.com/packs/media/pro_sla/sla_pro_bg@2x-9a63b09b.png";